/* Swanah Wears – Virtual Wardrobe interactions (no dependencies) */
(function () {
  'use strict';
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var moneyFormat = (window.DT_THEME && window.DT_THEME.moneyFormat) || 'Rs.{{amount}}';
  var X_ICON = `<svg viewBox='0 0 24 24' fill='none' aria-hidden='true'><path d='M6 6l12 12M18 6L6 18' stroke='currentColor' stroke-width='1.8' stroke-linecap='round'/></svg>`;
  var ESC_MAP = { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" };

  function money(cents) {
    var c = Number(cents) || 0;
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var k = m ? m[1] : 'amount';
    function n(d, t, s) {
      var p = (c / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.length > 1 ? p[0] + s + p[1] : p[0];
    }
    var v;
    if (k === 'amount_no_decimals') v = n(0, ',', '.');
    else if (k === 'amount_with_comma_separator') v = n(2, '.', ',');
    else if (k === 'amount_no_decimals_with_comma_separator') v = n(0, '.', ',');
    else v = n(2, ',', '.');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>'"]/g, function (c) { return ESC_MAP[c]; });
  }
  function pretty(v) {
    v = String(v);
    if (v.length <= 3) return v.toUpperCase();
    v = v.replace(/-/g, ' ');
    return v.charAt(0).toUpperCase() + v.slice(1);
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- toast + cart ---------- */
  var toastEl, toastTimer;
  function toast(html, isErr) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sw-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-error', !!isErr);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 6000);
  }
  function addedToast(added) {
    // The cart drawer already opened with the new item, so a toast would be redundant
    if (added && added._swDrawerOpened) return;
    var cartUrl = (window.routes && window.routes.cart_url) || root + 'cart';
    toast(`<span>Added to your cart</span><a href='${cartUrl}'>View cart</a><a href='${root}checkout'>Checkout</a>`);
  }
  function refreshCartBubble() {
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-icon-bubble'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        qsa('#cart-icon-bubble').forEach(function (el) { el.innerHTML = inner.innerHTML; });
      })
      .catch(function () {});
    document.dispatchEvent(new CustomEvent('sw:cart-updated'));
  }
  function addToCart(items) {
    var url = ((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    // Ask for the re-rendered drawer in the same request so it never shows a stale cart
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
        if (body.sections && d.sections) {
          try {
            drawer.renderContents({ id: items[0] && items[0].id, sections: d.sections });
            d._swDrawerOpened = true;
          } catch (e) { refreshCartBubble(); }
        } else {
          refreshCartBubble();
        }
        return d;
      });
    });
  }
  function qtyInit(scope) {
    qsa('[data-sw-qty]', scope).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (Number(input.value) || 1) + Number(b.dataset.step);
          input.value = Math.max(1, v);
        });
      });
    });
  }

  /* ---------- drag-to-scroll for mouse ---------- */
  function dragScroll(el) {
    var down = false, startX = 0, startLeft = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- hanger rails ---------- */
  function initRail(rail) {
    if (rail._sw) return;
    rail._sw = true;
    var wrap = rail.closest('[data-sw-rail-wrap]') || rail.parentNode;
    var scope = wrap.closest('[data-sw-rail-scope]') || wrap;
    var prev = qs('[data-sw-prev]', scope), next = qs('[data-sw-next]', scope);
    var step = function () { return Math.max(rail.clientWidth * 0.8, 240); };
    var update = function () {
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    var t;
    rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); });
    window.addEventListener('resize', update);
    dragScroll(rail);
    update();
    rail._swUpdate = update;
  }

  /* ---------- wardrobe compartments (tabs) ---------- */
  function initWardrobe(w) {
    var tabs = qsa('[role=tab]', w);
    if (!tabs.length) return;
    function activate(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus();
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) qsa('[data-sw-rail]', panel).forEach(function (r) { initRail(r); if (r._swUpdate) r._swUpdate(); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t); });
      t.addEventListener('keydown', function (e) {
        var j;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j !== undefined) { e.preventDefault(); activate(tabs[j], true); }
      });
    });
  }

  /* ---------- quick view ---------- */
  var qv;
  function ensureDialog() {
    if (qv) return qv;
    qv = document.createElement('dialog');
    qv.className = 'sw-dialog';
    qv.setAttribute('aria-label', 'Quick view');
    document.body.appendChild(qv);
    qv.addEventListener('click', function (e) { if (e.target === qv) qv.close(); });
    qv.addEventListener('close', function () { if (qv._trigger) qv._trigger.focus(); });
    return qv;
  }
  function findVariant(variants, sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var k = 0; k < sel.length; k++) { if (v.options[k] !== sel[k]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function openQuick(handle, trigger) {
    var d = ensureDialog();
    d._trigger = trigger;
    d.innerHTML = `<div class='sw-dialog__body'><p>Loading…</p></div>`;
    if (!d.open) d.showModal();
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
      .then(renderQuick)
      .catch(function () {
        d.innerHTML = `<div class='sw-dialog__body'><p>Sorry, this product could not be loaded.</p><a class='sw-link' href='${root}products/${esc(handle)}'>Open product page</a></div>`;
      });
  }
  function renderQuick(p) {
    var d = qv;
    // Prefer the in-stock variant closest to the product's own first variant, so a sold-out
    // "M / beige" opens on "L / beige" rather than jumping to another colour
    var own = p.variants[0];
    var first = p.variants.filter(function (v) { return v.available; })
      .map(function (v) {
        var score = 0;
        v.options.forEach(function (o, i) {
          var name = (p.options[i] && (p.options[i].name || p.options[i])) || '';
          if (own && o === own.options[i]) score += /colou?r/i.test(name) ? 10 : 1;
        });
        return { v: v, score: score };
      })
      .sort(function (a, b) { return b.score - a.score; })
      .map(function (x) { return x.v; })[0] || own;
    var opts = p.options.map(function (o, i) {
      var name = o.name || o;
      var values = o.values || [];
      if (values.length < 2 && (name === 'Title' || values[0] === 'Default Title')) return '';
      var pills = values.map(function (v) {
        var checked = first && first.options[i] === v ? 'checked' : '';
        return `<label class='sw-pill'><input type='radio' name='qv-${i}' value='${esc(v)}' ${checked}><span>${esc(pretty(v))}</span></label>`;
      }).join('');
      return `<fieldset class='sw-option' data-qv-opt='${i}'><legend>${esc(name)}</legend><div class='sw-pills'>${pills}</div></fieldset>`;
    }).join('');
    var media = (p.images || []).slice(0, 6).map(function (u, i) {
      return `<img src='${imgUrl(u, 900)}' alt='${esc(p.title)} – image ${i + 1}' loading='${i ? 'lazy' : 'eager'}' width='900' height='1125'>`;
    }).join('');
    d.innerHTML =
      `<button type='button' class='sw-icon-btn sw-dialog__close' aria-label='Close'>${X_ICON}</button>` +
      `<div class='sw-qv'><div class='sw-qv__media'>${media}</div><div class='sw-qv__info'>` +
      (p.type ? `<p class='sw-eyebrow'>${esc(p.type)}</p>` : '') +
      `<h2>${esc(p.title)}</h2><div class='sw-pdp__price'><span data-qv-price></span><s data-qv-compare hidden></s></div>` +
      `<p class='sw-stock' data-qv-stock></p><form data-qv-form novalidate>${opts}` +
      `<div class='sw-buy'><div class='sw-qty' data-sw-qty><button type='button' data-step='-1' aria-label='Decrease quantity'>−</button><input type='number' name='quantity' min='1' value='1' aria-label='Quantity'><button type='button' data-step='1' aria-label='Increase quantity'>+</button></div>` +
      `<button type='submit' class='sw-btn sw-btn--dark' data-qv-add>Add to cart</button></div></form>` +
      `<a class='sw-link' href='${esc(p.url)}'>View full details</a></div></div>`;
    qs('.sw-dialog__close', d).addEventListener('click', function () { d.close(); });
    var form = qs('[data-qv-form]', d);
    var cur = null;
    function sel() {
      return p.options.map(function (o, i) {
        var c = qs(`input[name='qv-${i}']:checked`, d);
        return c ? c.value : first.options[i];
      });
    }
    function upd() {
      var s = sel();
      cur = findVariant(p.variants, s);
      var b = qs('[data-qv-add]', d), st = qs('[data-qv-stock]', d), c = qs('[data-qv-compare]', d);
      if (!cur) { b.disabled = true; b.textContent = 'Unavailable'; st.textContent = ''; return; }
      qs('[data-qv-price]', d).textContent = money(cur.price);
      if (cur.compare_at_price > cur.price) { c.textContent = money(cur.compare_at_price); c.hidden = false; } else { c.hidden = true; }
      b.disabled = !cur.available;
      b.textContent = cur.available ? 'Add to cart' : 'Sold out';
      st.textContent = cur.available ? 'In stock' : 'Sold out';
      st.className = 'sw-stock' + (cur.available ? '' : ' is-out');
      qsa('[data-qv-opt]', d).forEach(function (f) {
        var i = Number(f.dataset.qvOpt);
        qsa('input', f).forEach(function (inp) {
          var t = s.slice(); t[i] = inp.value;
          var v = findVariant(p.variants, t);
          inp.closest('.sw-pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    form.addEventListener('change', upd);
    upd();
    qtyInit(form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!cur || !cur.available) return;
      var b = qs('[data-qv-add]', d);
      b.classList.add('is-loading');
      addToCart([{ id: cur.id, quantity: Number(form.elements.quantity.value) || 1 }])
        .then(function (added) { d.close(); addedToast(added); })
        .catch(function (err) { toast(esc(err.message), true); })
        .then(function () { b.classList.remove('is-loading'); });
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sw-quickview]');
    if (!t) return;
    e.preventDefault();
    openQuick(t.getAttribute('data-sw-quickview'), t);
  });

  /* ---------- wardrobe rail hover: the hovered garment comes forward, its neighbours slide apart ---------- */
  var PUSH_ROW = '.sw-rail, .sw-grid, #product-grid, .sw-cabin__row';
  var PUSH_ITEM = '.sw-hanger, .sw-cabin__piece';
  var PUSH_FALLOFF = [1, 0.62, 0.38, 0.22, 0.12];
  var canPush = !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function pushItems(row) {
    return qsa(PUSH_ITEM, row).filter(function (el) { return el.closest(PUSH_ROW) === row; });
  }
  function releaseRow(row) {
    if (!row || !row._swFocus) return;
    pushItems(row).forEach(function (el) {
      el.classList.remove('is-focus', 'is-left', 'is-right');
      el.style.setProperty('--sw-push', '0px');
    });
    row.classList.remove('is-browsing');
    row._swFocus = null;
  }
  function focusGarment(item) {
    var row = item.closest(PUSH_ROW);
    if (!row || row._swFocus === item || row.classList.contains('is-dragging')) return;
    var all = pushItems(row);
    var top = item.getBoundingClientRect().top;
    // Only the hangers on the same rail (row) move; other grid rows stay put
    var line = all.filter(function (el) { return Math.abs(el.getBoundingClientRect().top - top) < 12; });
    var idx = line.indexOf(item);
    var rowBox = row.getBoundingClientRect();
    // Rows can ask for a bigger push (the hero's overlapping garments need ~30% to clear)
    var ratio = parseFloat(getComputedStyle(row).getPropertyValue('--sw-push-ratio')) || 0.1;
    var step = Math.min(44, Math.max(10, item.getBoundingClientRect().width * ratio));
    var GAP = 6;
    // Resting positions (minus any push already applied), then how far each hanger may slide:
    // the row's edge stops the end hangers like a wardrobe wall, and each hanger can only move as far
    // as the one beyond it lets it, so pushed cards bunch up instead of overlapping
    var base = line.map(function (el) {
      var r = el.getBoundingClientRect();
      var tf = getComputedStyle(el).transform;
      var cur = tf && tf !== 'none' ? new DOMMatrixReadOnly(tf).m41 : 0;
      return { left: r.left - cur, right: r.right - cur };
    });
    var shifts = line.map(function () { return 0; });
    var want = function (i) { return step * PUSH_FALLOFF[Math.min(Math.abs(i - idx) - 1, PUSH_FALLOFF.length - 1)]; };
    for (var i = line.length - 1; i > idx; i--) {
      var limitR;
      if (i === line.length - 1) limitR = rowBox.right - base[i].right;
      else {
        var gapR = base[i + 1].left - base[i].right;
        limitR = gapR < 0 ? Infinity : shifts[i + 1] + gapR - GAP; // overlapping rows (hero) may stay overlapped
      }
      shifts[i] = Math.max(0, Math.min(want(i), limitR));
    }
    for (var j = 0; j < idx; j++) {
      var limitL;
      if (j === 0) limitL = base[j].left - rowBox.left;
      else {
        var gapL = base[j].left - base[j - 1].right;
        limitL = gapL < 0 ? Infinity : -shifts[j - 1] + gapL - GAP;
      }
      shifts[j] = -Math.max(0, Math.min(want(j), limitL));
    }
    all.forEach(function (el) {
      el.classList.add('sw-push-item');
      var i = line.indexOf(el);
      if (i === -1) {
        el.classList.remove('is-focus', 'is-left', 'is-right');
        el.style.setProperty('--sw-push', '0px');
        return;
      }
      var d = i - idx;
      if (d === 0) {
        el.classList.remove('is-left', 'is-right');
        el.classList.add('is-focus');
        el.style.setProperty('--sw-push', '0px');
        return;
      }
      var f = PUSH_FALLOFF[Math.min(Math.abs(d) - 1, PUSH_FALLOFF.length - 1)];
      var dir = d < 0 ? 'is-left' : 'is-right';
      el.classList.remove('is-focus');
      if (!el.classList.contains(dir)) {
        // Restart the settle-sway when a hanger changes direction
        el.classList.remove('is-left', 'is-right');
        void el.offsetWidth;
        el.classList.add(dir);
      }
      el.style.setProperty('--sw-push', shifts[i].toFixed(1) + 'px');
      el.style.setProperty('--sw-tilt', (Math.sign(d) * 3.2 * f).toFixed(2) + 'deg');
    });
    row.classList.add('is-browsing');
    row._swFocus = item;
  }
  if (canPush) {
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var item = e.target.closest && e.target.closest(PUSH_ITEM);
      if (item) focusGarment(item);
    });
    document.addEventListener('pointerout', function (e) {
      var row = e.target.closest && e.target.closest(PUSH_ROW);
      if (row && !(e.relatedTarget && row.contains(e.relatedTarget))) releaseRow(row);
    });
    document.addEventListener('focusin', function (e) {
      var item = e.target.closest && e.target.closest(PUSH_ITEM);
      if (item) focusGarment(item);
    });
    document.addEventListener('focusout', function (e) {
      var row = e.target.closest && e.target.closest(PUSH_ROW);
      if (row && !(e.relatedTarget && row.contains(e.relatedTarget))) releaseRow(row);
    });
  }

  function initA(scope) {
    qsa('[data-sw-rail]', scope).forEach(function (r) { if (!r.closest('[hidden]')) initRail(r); });
    qsa('[data-sw-wardrobe]', scope).forEach(initWardrobe);
  }
  window.SWW = { qs: qs, qsa: qsa, reduce: reduce, money: money, esc: esc, toast: toast, addedToast: addedToast, addToCart: addToCart, qtyInit: qtyInit, dragScroll: dragScroll, findVariant: findVariant };
  // Re-measure a row's push after its layout changed (the hero's cabins spread their rail when opened)
  window.SWW.refreshPush = function (row) {
    var f = row && row._swFocus;
    if (!f) return;
    row._swFocus = null;
    focusGarment(f);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initA(document); });
  else initA(document);
  document.addEventListener('shopify:section:load', function (e) { initA(e.target); });
})();